// frontend/src/components/homepage/artefacts/PushStack.js
//
// Tile 03's artefact: two push notifications sliding in on a 6s loop, the
// second 1.2s behind. Pure CSS motion (`hl-pushIn`); under motion-off the
// keyframe is dead and both cards sit at their resting state, visible.
//
// `hotText` (optional) replaces the FIRST card's line. A profession page passes
// its own (the homepage's names a labour lawyer, which reads wrong on
// /accountants); the homepage passes nothing and renders PUSH_ITEMS verbatim.

import React, { memo } from "react";

export const PUSH_ITEMS = [
  { text: 'הזדמנות חמה חדשה - עו"ד דיני עבודה', time: "עכשיו", hot: true },
  { text: "תזכורת follow-up: פנייה למור", time: "10:20", hot: false },
];

function PushStack({ hotText }) {
  const items = hotText ? [{ ...PUSH_ITEMS[0], text: hotText }, ...PUSH_ITEMS.slice(1)] : PUSH_ITEMS;
  return (
    <>
      {items.map((item, index) => (
        <div
          key={item.text}
          className={`hl-ft-n hl-ft-n${index + 1}${item.hot ? " hl-ft-e" : ""}`}
          aria-hidden="true"
        >
          <i />
          <div>{item.text}</div>
          <span>{item.time}</span>
        </div>
      ))}
    </>
  );
}

export default memo(PushStack);
